var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvocacyLeaf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 81,
    viewBox: "0 0 61 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44923 55.515C7.10322 58.2992 3.57365 73.0466 2.10212 80.0723L-2.11021e-05 66.7292C1.90364 67.8042 3.02663 66.1937 3.35018 65.254L5.44738 57.7636C5.44738 57.7636 6.33997 55.8707 6.62334 55.1176C6.90672 54.3645 9.67633 51.0776 9.67633 51.0776L9.70496 48.1261C10.4564 41.8161 12.9268 27.631 16.7973 21.3704C21.6355 13.5446 35.6948 8.52931 40.2348 7.72601C43.8668 7.08337 54.7427 2.31726 59.7267 0.0145316C60.3264 -0.141432 60.6062 0.887901 56.9284 6.25293C52.3312 12.9592 57.351 29.0915 46.5915 40.1935C37.9839 49.0751 22.588 48.9526 15.9659 47.7811L9.44923 55.515Z",
    fill: "#D1DAAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvocacyLeaf);
export default __webpack_public_path__ + "static/media/advocacy-leaf.68c351b547a5fbabbe3a563ccc9fbee1.svg";
export { ForwardRef as ReactComponent };